import {of as observableOf, Observable} from 'rxjs';

import {catchError, delay, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {
    GenericApiResponse,
} from '../apibase.api';
import { HttpClient } from '@angular/common/http';
import {CommentPayload, Tag, WebmateComment} from '@webmate-web-core/shared/types/tag';

@Injectable({
    providedIn: 'root'
})
export class TagApi {

    constructor(public OAuth2AuthService: AuthService, private http: HttpClient) {
    }

    getTagsForResource$(resourceId: string): Observable<Tag[]> {
        return this.http.get<Tag[]>(`/resources/${resourceId}/tags`).pipe(map(r => r ?? []))
    };

    addTagsToResource$(projectId: string, resourceType: string, resourceId: string, tags: Tag[]): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>(`/projects/${projectId}/resources/${resourceType}/${resourceId}/tags`, tags);
    };

    deleteTag(resourceId: string, tagName: string): Observable<GenericApiResponse> {
        return this.http.delete<GenericApiResponse>(`/resources/${resourceId}/tags/${tagName}`);
    };

    getCommentsForResource$(resourceId: string): Observable<WebmateComment[]> {
        return this.http.get<WebmateComment[]>(`/resources/${resourceId}/comments`).pipe(map(r => r ?? []))
    };

    addCommentToResource$(projectId: string, resourceType: string, resourceId: string, comment: CommentPayload): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>(`/projects/${projectId}/resources/${resourceType}/${resourceId}/comments`, comment);
    };

}
